/**
 * Shared redirect state for the query-param → hash-route redirect system.
 *
 * Lives in its own file (no imports from routes/components) to avoid
 * circular-dependency issues between App.tsx ↔ routes.ts ↔ RootLayout.tsx.
 */

let _pendingRedirectPath: string | null = null;

export function setPendingRedirect(path: string): void {
  _pendingRedirectPath = path;
}

export function getPendingRedirect(): string | null {
  return _pendingRedirectPath;
}

/** Read and clear — consumed once by RootLayout Layer 3 fallback */
export function consumePendingRedirect(): string | null {
  const p = _pendingRedirectPath;
  _pendingRedirectPath = null;
  return p;
}
